import React from 'react';
import './MetricCard.css';

const MetricCard = ({ title, value, subtitle, icon: Icon, trend, variant = 'default' }) => {
  return (
    <div className="metric-card">
      <div className="metric-card-content">
        <div className="metric-text">
          <p className="metric-title">{title}</p>
          <p className="metric-value">{value}</p>
          {subtitle && <p className="metric-subtitle">{subtitle}</p>}
          {trend && (
            <div className={`metric-trend ${trend.isPositive ? 'positive' : 'negative'}`}>
              <span>{trend.isPositive ? '+' : ''}{trend.value}%</span>
              <span className="muted">vs last month</span>
            </div>
          )}
        </div>
        <div className={`metric-icon ${variant}`}>
          <Icon />
        </div>
      </div>
    </div>
  );
};

export default MetricCard;
